import $ from 'jquery';
let ajax = {
  /**
   * Send http request to stage
   * @param {object} settings   - Settings object
   * @example
   * {
   *  url: 'vehicleSearch',
   *  data: { test: 'testValue' },
   *  method: 'POST',
   *  callback: function(response, statusCode, statusMessage) {
   *    // Do sth
   *  }
   * }
   */
  ajaxRequest: function(settings = {}) {
    let self = this;

    if(!settings.hasOwnProperty('target')) {
      throw new Error('Ajax-request needs target property!');
    }

    settings.method = !settings.hasOwnProperty('method') ? 'GET' : settings.method;
    settings.data = !settings.hasOwnProperty('data') ? {} : settings.data;
    settings.callback = !settings.hasOwnProperty('callback') ? null : settings.callback;
    settings.target = '/stage-ajax/' + settings.target;
    settings.async = !settings.hasOwnProperty('async') ? settings.async : true;
    settings.data['stage-language'] = !settings.data.hasOwnProperty('stage-language') ? 'fi' : settings.data['stage-language'];

    $.ajax({
      url: settings.target,
      method: settings.method,
      data: settings.data,
      dataType: 'json',
      async: settings.async,
      success: function(responseData, responseStatus, xhr) {
        if(xhr.status !== 200) {
          console.warn('Response status was not 200 (in this case it is: ' + responseData.status + ')');
          console.log(responseData);
        }

        if(typeof settings.callback === 'function') {
          settings.callback(responseData, responseStatus, xhr);
        }
      },
      error: function(response, responseStatus, responseMessage) {
        // Refresh new token
        self._getStageToken();
        settings.callback(response, responseStatus, responseMessage);
      }
    });
  },

  _getStageToken: function() {
    if(document.getElementById('ajax-token')) {
      $.ajax({
        url: '/stage-ajax/getStageToken',
        data: { 'stage-language': 'fi' },
        method: 'GET',
        success: function(response) {
          // Add new token to body hidden input
          document.getElementById('ajax-token').value = response.token;
        }
      });
    }
  }
};
module.exports = ajax;